import axiosInstance from "../../utilities/interceptorUtilities";
import { genericError } from "../../constants/messages";
import { PERSONAL } from "../../constants/keys";
import { timeToMS } from "../../utilities/dataUtilities";

export const GET_CONFIG = "GET_CONFIG";
export const SET_VIEW = "SET_VIEW";
export const SET_LOADING = "SET_LOADING";
export const SET_ORIGIN = "SET_ORIGIN";
export const SET_ALERT_MODAL = "SET_ALERT_MODAL";
export const SET_PROMPT_MODAL = "SET_PROMPT_MODAL";
export const SET_BUTTON_HEADER = "SET_BUTTON_HEADER";
export const SET_POLICY_TYPE = "SET_POLICY_TYPE";
export const GET_REFRESH_TOKEN = "GET_REFRESH_TOKEN";
export const SET_VISIBLE_SELECTORS = "SET_VISIBLE_SELECTORS";
export const SET_APP = "SET_APP";
export const SET_ANONYMOUS = "SET_ANONYMOUS";
export const GET_IDLE_SETTINGS = "GET_IDLE_SETTINGS";

export const getConfig = () => {
  return async (dispatch) => {
    try {
      let url;

      if (process.env.NODE_ENV === "development") {
        url = process.env.PUBLIC_URL + "/assets/config.json";
      } else {
        url = "assets/config.json";
      }

      let response = await axiosInstance.get(url);

      dispatch({ type: GET_CONFIG, config: response.data });
    } catch (err) {
      dispatch(setAlertModal(true, "error", genericError));
      setTimeout(() => {
        dispatch(setAlertModal(false, ""));
      }, 5000);
    }
  };
};

export const setView = (view) => {
  return async (dispatch) => {
    try {
      dispatch({ type: SET_VIEW, view });
    } catch (err) {
      dispatch(setAlertModal(true, "error", genericError));
      setTimeout(() => {
        dispatch(setAlertModal(false, ""));
      }, 5000);
    }
  };
};

export const setVisibleSelectors = (auto, property, liability, home, wc, vehicle) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: SET_VISIBLE_SELECTORS,
        auto,
        property,
        liability,
        home,
        wc,
        vehicle
      });
    } catch (err) {
      dispatch(setAlertModal(true, "error", genericError));
      setTimeout(() => {
        dispatch(setAlertModal(false, ""));
      }, 5000);
    }
  };
};

export const setLoading = (isLoading) => {
  return async (dispatch) => {
    try {
      dispatch({ type: SET_LOADING, isLoading });
    } catch (err) {
      dispatch(setAlertModal(true, "error", genericError));
      setTimeout(() => {
        dispatch(setAlertModal(false, ""));
      }, 5000);
    }
  };
};

export const setOrigin = (origin) => {
  return async (dispatch) => {
    try {
      dispatch({ type: SET_ORIGIN, origin });
    } catch (err) {
      dispatch(setAlertModal(true, "error", genericError));
      setTimeout(() => {
        dispatch(setAlertModal(false, ""));
      }, 5000);
    }
  };
};

export const setAlertModal = (isShowing, modalType, bodyMessage) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: SET_ALERT_MODAL,
        alert: { show: isShowing, type: modalType, body: bodyMessage },
      });
    } catch (err) {
      dispatch(setAlertModal(true, "error", genericError));
      setTimeout(() => {
        dispatch(setAlertModal(false, ""));
      }, 5000);
    }
  };
};

export const setPromptModal = (isShowing, properties) => {
  return async(dispatch) => {
    try {
      dispatch({
        type: SET_PROMPT_MODAL,
        prompt: { show: isShowing, properties }
      });
    } catch(err) {
      console.error(err);
    }
  };
};

export const setButtonHeader = (isShowing) => {
  return async (dispatch) => {
    try {
      dispatch({ type: SET_BUTTON_HEADER, isShowing });
    } catch (err) {
      dispatch(setAlertModal(true, "error", genericError));
      setTimeout(() => {
        dispatch(setAlertModal(false, ""));
      }, 5000);
    }
  };
};

export const setPolicyType = (personal, commercial, policyType) => {
  return async (dispatch, getState) => {
    try {
      const userInfo = getState().user.userInfo;

      if (personal && commercial) {
        dispatch(setButtonHeader(true));
      }

      if (policyType) {
        if (userInfo) {
          userInfo.AccountId = policyType === PERSONAL ? personal : commercial;
          sessionStorage.setItem("ud", JSON.stringify(userInfo));
        }

        dispatch({
          type: SET_POLICY_TYPE,
          policyType: { personal, commercial, active: policyType },
        });
      }
    } catch (err) {
      dispatch(setAlertModal(true, "error", genericError));
      setTimeout(() => {
        dispatch(setAlertModal(false, ""));
      }, 5000);
    }
  };
};

export const setAnonymous = (isAnonymous) => {
  return (dispatch) => {
    dispatch({ type: SET_ANONYMOUS, isAnonymous });
  };
};

export const getRefreshToken = (user) => {
  return async (dispatch, getState) => {
    try {
      let url = process.env.REACT_APP_API_URL + "/api/Security/RefreshToken";
      let body;

      if (user === "user") {
        let userInfo = getState().user.userInfo;
        body = { CurrentRefreshToken: userInfo.RefreshToken };
        const response = await axiosInstance.post(url, body, {
          headers: { "content-type": "application/json" },
          withCredentials: true,
        });

        userInfo.RefreshToken = response.data.RefreshToken;
        const info = {
          ui: userInfo.UserId,
          ai: userInfo.AccountId,
          rt: userInfo.RefreshToken,
          si: userInfo.SessionId,
          ii: userInfo.IsImpersonate,
          full: userInfo.UserFullName,
          eid: userInfo.UserEmailId,
        };
        sessionStorage.setItem("ud", JSON.stringify(info));
      } else {
        let agentInfo = getState().user.agentInfo;
        body = {
          CurrentRefreshToken: agentInfo.refreshToken,
          Id: agentInfo.userId,
        };
        if (getState().user.employeeAuthenticated) {
          url = url + "?isAgent=false";
        }
        const response = await axiosInstance.post(url, body, {
          headers: { "content-type": "application/json" },
          withCredentials: true,
        });

        agentInfo.refreshToken = response.data.RefreshToken;
        sessionStorage.setItem("agent-info", JSON.stringify(agentInfo));
      }
    } catch (err) {
      dispatch(setAlertModal(true, "error", genericError));
      setTimeout(() => {
        dispatch(setAlertModal(false, ""));
      }, 5000);
    }
  };
};

export const saveStateToSession = () => {
  return (dispatch, getState) => {
    try {
      sessionStorage.setItem("appState", JSON.stringify(getState()));
    } catch (err) {
      dispatch(setAlertModal(true, "error", genericError));
    }
  };
};

export const setApp = (app) => {
  return (dispatch) => {
    dispatch({ type: SET_APP, app });
  };
};

//param selectorName the name of the selector in the DOM
export const scrollToTop = (selectorName) => {
  const scroller = document.querySelector(selectorName);
  scroller.scroll(0, 0);
};

export const getIdleSettings = () => {
  return async (dispatch) => {
    try {
      let url = process.env.REACT_APP_API_URL + "/api/Login/GetApplicationSettings";
     
        const response = await axiosInstance.get(url, {
          headers: { "content-type": "application/json" },
          withCredentials: true,
        });

        const data = response.data.SessionTimeoutSettings;

        const settings = {
          timeout: timeToMS(data.RefreshTokenWindow),
          promptBeforeIdle: 300000,
        };

        dispatch({ type: GET_IDLE_SETTINGS, settings });
    } catch (err) {
      console.error(err);
    }
  };
};
